// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html * {
	transition-property: all !important;
	transition-duration: 0.2s ease-in-out !important;
}

.logo {
	max-width: 100%;
	margin-bottom: 0;
	padding-right: 1.5rem;
	padding-left: 1.5rem;
	padding-top: 1rem;
	display: flex;
}
.main-panel {
	min-height: 100vh;
}
.miniLogo {
	height: 35px;
	display: grid;
	margin-bottom: 10px;
}

/* DealContent.css */

.row.d-flex.align-items-stretch {
	display: flex;
	align-items: stretch;
}

.card.h-100 {
	height: 100%;
}

hr,
.hr {
	margin: auto;
}

.cursor-pointer {
	cursor: pointer;
}
.login-form {
	max-width: 350px;
}

.login-page,
forgotten-password {
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	background-size: cover;
	background-position: center;
	background: rgb(63, 94, 251);
	background: radial-gradient(
		circle,
		rgba(63, 94, 251, 1) 0%,
		rgba(0, 78, 137, 1) 100%
	);
}

.toggle-btn {
	position: absolute;
	bottom: 1rem;
	z-index: 99;
	right: 3em;
	cursor: pointer;
	font-size: 0.7rem;
	text-decoration: underline;
}

a:hover,
.a:hover {
	text-decoration: none;
}
.dropdown-menu {
	min-width: 0 !important;
}

.sidebar-logo {
	max-width: 100%;
}
/* override bs class rounding */
.rounded {
	border-radius: 12px !important;
}

.gallery-image {
	max-width: 350px;
}

.inv-description {
	min-height: 250px;
	height: "auto";
	overflow: scroll;
}

/* constrain header img */
.headerImg {
	max-width: 80%;
}

.nav-pills-primary .nav-item .nav-link,
.nav-pills-secondary .nav-item .nav-link {
	color: #6e6e6e !important;
}
.larger-tabs .nav-link {
	font-size: 1.25rem; /* Increase font size */
	padding: 0.75rem 1.5rem; /* Adjust padding for larger tabs */
}

.bg-primary > .nav-item > .nav-link {
	color: white !important;
}

.sale-container {
	display: flex;
	flex-wrap: wrap;
}

.sale-item {
	width: 100%;
	margin-bottom: 1rem;
}

@media (min-width: 1800px) {
	.sale-item {
		width: 50%;
		padding: 0 12px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
}

@media (min-width: 1800px) {
	.sale-item .row {
		justify-content: space-between;
		align-items: center;
	}
}

.sale-item .row .col-6 {
	display: flex;
	align-items: center;
}

.stock-cell-container {
	display: flex;
	flex-direction: column;
	width: 100%;
}

.stock-cell-item {
	width: 100%;
	padding: 2px 0;
}

.singleCell .stock-cell-container {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.nav-pills-primary .nav-item .nav-link.active,
.nav-pills-secondary .nav-item .nav-link.active {
	color: #fff !important;
}

.btn-outline-secondary:not(:disabled):not(.disabled).active:focus {
	box-shadow: none;
}

/* branded button links */
.btn-link-danger {
	background-color: transparent !important;
	color: #c1292e;
}

.btn-link-danger:hover {
	background-color: #cc2936 !important;
	color: white !important;
}
/* branded button links */
.btn-link-warning:hover {
	background-color: #fcd581 !important;
	color: #777 !important;
}

/* branded button links */
.btn-link-success {
	background-color: #329f5b !important;
	color: white !important;
}

/* branded button links */
.btn-link-success:hover {
	background-color: #1ada63 !important;
}
/* custom large top margin */

.mt-10 {
	margin-top: 25%;
}

/* add bg to form inputs */

.input-group-prepend .input-group-text {
	background-color: #b8d5ff;
	padding-right: 0.5rem !important;
}

.dropdown-item > a:hover {
	color: white !important;
}

.sidebar .logo .simple-text .logo-img img,
.logo-img {
	width: 80%;
	height: 80%;
	background-color: none !important;
	padding: 3px;
}

.card-stats .card-body .numbers .card-category {
	font-size: 14px;
	line-height: 1.4em;
}

.vertical-align {
	margin-top: 20%;
}

.sidebar .logo a.logo-normal {
	padding: 5px 0 8px;
}

.formsCard {
	overflow: scroll;
}

.bigText {
	font-size: 1.5rem !important;
}
.left-align label {
	text-align: left;
}

.plus-sign {
	line-height: 5.8em;
}
@media (max-width: 768px) {
	.plus-sign {
		line-height: 6.4em;
	}
}

/* Wrapper style */
.inv-desc-box-wrapper {
	display: block;
	min-height: 20px; /* minimum height of the textarea */
	overflow: hidden;
}

td > input {
	position: inherit !important;
}

.card-header {
	padding: 0 0.5rem;
}

/* Textarea style */
.inv-desc-box {
	width: 100%;
	height: 100% !important;
	min-height: 100%;
	overflow: hidden;
}

/* Default min-height for larger screens */
.invDescription {
	min-height: 175px;
}

/* Increase min-height for large screens (1420px and up) */
@media (min-width: 1420px) {
	.invDescription {
		min-height: 250px;
	}
}

/* Increase min-height for medium screens (1020px to 1419px) */
@media (min-width: 1020px) and (max-width: 1419px) {
	.invDescription {
		min-height: 300px;
	}
}

/* Increase min-height for small screens (569px to 1019px) */
@media (max-width: 1019px) and (min-width: 569px) {
	.invDescription {
		min-height: 450px;
	}
}

/* Increase min-height for mobile screens (max-width: 568px) */
@media (max-width: 568px) {
	.invDescription {
		min-height: 700px;
	}
}

.h3,
h3 {
	margin-bottom: 0 !important;
}

.row {
	margin-left: 0 !important;
	margin-right: 0 !important;
}

.customNav {
	box-shadow: 0 0 4px rgb(179, 178, 178);
	padding-top: 0 !important;
	padding-bottom: 0 !important;
}

b,
strong {
	font-weight: lighter;
}
.hide {
	display: none !important;
}

.dealImg {
	max-height: 100px;
}

/* camera styles */
.react-html5-camera-photo .video-wrapper video {
	height: auto !important;
	width: 30% !important;
	margin: 0 auto;
}

.radioFont {
	font-weight: lighter;
}

.rt-td > div > img,
.singleCell > img {
	width: auto;
	max-height: 6.5em !important;
}

.rt-td > div > img,
.singleCell {
	display: flex;
	justify-content: center;
	align-items: center;
}

/* @media (min-width: 1400px) {
	.rt-td > div > img,
	.singleCell > img {
		width: auto;
		max-height: 70px !important;
	}
} */

.SiriusXM {
	min-width: 150px;
	max-width: 250px;
	width: 100%;
}

/* hide elements on smaller screens */
@media (max-width: 1400px) {
	.noMobile,
	#noMobile {
		display: none !important;
	}
}

/* hide elements on smaller screens */
@media (min-width: 1400px) {
	.noDesktop,
	#noDesktop {
		display: none !important;
	}
}

.responsive-table {
	overflow-x: auto;
	width: 100%;
}

/* styles.css */
@media (max-width: 768px) {
	.table thead th {
		position: relative;
		z-index: 1;
		background: #f8f9fa; /* Adjust based on your theme */
		top: 0;
	}
	.table-bordered thead th {
		border: 1px solid #dee2e6;
	}
}

/* hide elements at 768px */
@media (max-width: 768px) {
	/* .onMobileScreen,
	#onMobileScreen, */
	.ReactTable th {
		display: block !important;
	}

	.historyButtons img {
		height: 120px;
	}

	.historyButtons,
	.modal-dialog {
		width: 100% !important;
		margin: 10px auto;
		padding: 10px;
	}

	.partner-card {
		width: 250px;
		cursor: pointer;
	}

	.sticky-header {
		position: -webkit-sticky;
		position: sticky;
		top: 60px;
		z-index: 999999999;
	}

	.deal-total {
		text-align: center;
	}
	.row .form-group,
	.form-group {
		padding-right: 15px;
		padding-left: 15px;
	}

	.card td,
	.card th,
	.forms-table tr,
	.form-group .forms-table {
		min-width: 180px;
		width: 100% !important;
		float: left;
		margin: 0 auto;
	}

	.card th:first-child {
		min-width: 0 !important;
	}

	table,
	tbody {
		overflow: hidden;
	}

	tr {
		display: flex;
		flex-wrap: nowrap;
		padding: 10px 0;
	}
	td {
		display: block;
		flex: 1 1; /* to evenly distributs flex elements */
		border: none !important;
		padding: 0;
		margin: 0px !important;
		position: relative;
	}
}

.tabNav > li > a.active {
	text-decoration: underline !important;
}

.tabNav:hover {
	cursor: pointer;
}

.tabNav {
	display: flex;
	justify-content: center;
}

#actionDropdownItem:hover {
	background: none;
}

#actionDropdownItem div,
#actionDropdownItem button {
	width: 100%;
	text-align: center;
}

iframe[style*="z-index: 2147483647"] {
	display: none !important;
}

.pageHeader {
	margin-top: 3rem;
	padding-bottom: 0.5rem;
	min-height: 53px;
}

@media (max-width: 768px) {
	.pageHeader {
		margin-top: 0;
	}
}

/* line height made even for sidebar icons */
.sidebar
	.sidebar-wrapper
	> .nav
	[data-toggle="collapse"]
	~ div
	> ul
	> li
	> a
	i {
	line-height: 30px;
}

/* move to sass file */

.btn.btn-link-black {
	color: #000;
	background-color: transparent;
}

.rt-resizable-header-content {
	text-align: center;
}

.sidebar[data-color="sidebar"] .nav li a {
	color: #f7f7f7;
}

/* add red asterix to req fields */
.required:after {
	content: " *";
	color: red;
}

.font-xs {
	font-size: 0.8em;
}

/* Styling for table cells */
.singleCell {
	font-size: var(--base-font-size);
	padding: 0 3px;
	display: flex;
	justify-content: center;
	justify-content: var(--cell-justify-content, center);
	align-items: center;
	flex-direction: row;
	overflow: hidden;
}

.table-auto-width tr > td:first-child,
.table-auto-width tr > th:first-child {
	width: auto !important;
	/* Override min-width for the first child */
	min-width: 0 !important;
	min-width: initial !important;
	/* If flex is causing issues, reset it */
	display: table-cell !important;
}

.status {
	font-size: 14px;
	font-weight: 400;
}
/*
.sidebar-mini .sidebar {
	display: block;
	z-index: 999999;
}
*/
.mt-half {
	margin-top: 0.8rem;
}

.lg-p {
	font-size: 1rem;
}

.pt-3-half {
	padding-top: 1.3rem !important;
}

.selector {
	min-width: 200px;
}

.main-panel .content {
	padding-left: 0;
	padding-right: 0;
}

table tbody tr td input {
	background-color: inherit;
}

.lenderImg {
	height: 80px !important;
	margin-bottom: 12px;
}

.bodyHeight {
	min-height: 110vh !important;
}

.adImage {
	max-height: 45px !important;
	margin-bottom: 10px;
}

.modal-xl {
	max-width: 94% !important;
}

.btn i,
.navbar .navbar-nav > a.btn i {
	margin-right: 0 !important;
}

/* InventoryListData.css */

/* Default table view */
.inventory-table {
	display: block;
}

/* Hide card view by default */
.inventory-card-list {
	display: none;
}

/* Switch to card view at 1400px */
@media (max-width: 1400px) {
	.inventory-table {
		display: none;
	}
	.inventory-card-list {
		display: block;
	}
}

.btn {
	outline: none !important;
	border: none;
}

/* hide elements on smaller screens */
@media (max-width: 1920px) {
	.sidebarText {
		display: none !important;
	}
}

.old-row {
	margin: 0 -15px !important;
}

.customer-profile {
	max-height: 128px;
	margin-bottom: 0.3rem;
	box-shadow: 0 0 2px darkgrey;
}

.hide {
	display: none;
}

.bottom-nav a {
	float: left;
	display: block;
	color: #f2f2f2;
	text-align: center;
	padding: 14px 16px;
	text-decoration: none;
	font-size: 17px;
}

.bottom-nav a:hover {
	background: #f1f1f1;
	color: black;
}

.bottom-nav a.active {
	background-color: #04aa6d;
	color: white;
}

.btn-active {
	background-color: #04aa6d;
	color: #5a5a5a;
}

/* styles.css */
.toggle-button {
	background-color: inherit;
}

.toggleContainer {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0.5rem 0;
}

@media (max-width: 768px) {
	.toggleContainer {
		justify-content: center;
		margin-bottom: 20px;
	}
}

/* floating save button */

.float-button {
	position: fixed;
	right: 20px;
	bottom: -115px;
	transition: all 0.2s ease-in 0s;
	z-index: 999;
	cursor: pointer;
	box-shadow: 0 0 2px 0px rgb(179, 178, 178);
	height: 150px;
	font-size: 16px;
	font-weight: 600;
}

.hi-z-index {
	z-index: 9999;
}

.float-button:hover {
	bottom: -110px;
	font-size: 18px;
}

.float-button-modal {
	position: fixed;
	right: 135px;
	bottom: 30px;
	left: 170px;
	transition: all 0.2s ease-in 0s;
	z-index: 9999;
	cursor: pointer;
	text-align: right;
}

.welcomeImage {
	width: 500px;
	height: 300px;
}
@media screen and (max-width: 768px) {
	.welcomeImage {
		width: 100%;
		height: 100%;
	}
}

.article-card {
	width: 18rem;
}
@media screen and (max-width: 768px) {
	.article-card {
		width: 100%;
	}
}

.headerToggle {
	position: absolute !important;
	top: 4px;
	left: 49%;
	z-index: 9999;
}
.pt-6 {
	padding-top: 3.5rem;
}

.col-xl-6 {
	flex: 0 0 49%;
}

.collapse-button {
	display: block;
	width: 100%;
}

.collapse-content.collapsed {
	display: none;
}

.collapsed-content.expanded {
	display: block;
}

@media (max-width: 768px) {
	.mobile-pb-1 {
		padding-bottom: 1rem;
	}
}

.btn-block + .btn-block {
	margin-top: 0 !important;
}

.attachmentBtnCol {
	justify-content: flex-start;
}

@media (max-width: 768px) {
	.attachmentBtnCol {
		justify-content: center;
	}
}

.modal-body {
	padding: 15px;
}

@media (max-width: 1300px) {
	.mobileHeading {
		padding-top: 5rem !important;
	}
}

/* lazy but i cant find in sass files... */

.vehicle-photo img {
	border-radius: 10px !important;
	overflow: hidden !important;
	margin-top: 10px;
}

.nav-pills-primary .nav-item .nav-link,
.nav-pills-secondary .nav-item .nav-link {
	box-shadow: 0 0 2px #00000042;
	border: 0;
	margin: 0;
	border-radius: 30px !important;
}
.css-12jo7m5 {
	font-size: 18px !important;
}

.nav-search,
.search {
	display: none;
}

.avatar {
	max-width: 30px;
	padding-top: 0.4rem;
}

.content {
	margin-top: 60px !important;
}

.main-panel {
	background-color: #f7f7f7 !important;
	transition: all 0rgb (173, 173, 173) c-bezier(0.685, 0.0473, 0.346, 1);
	transition-property: all;
	transition-duration: 0.5s;
	transition-timing-function: cubic-bezier(0.685, 0.0473, 0.346, 1);
}

.main-panel > .content {
	padding: 0;
}

.dropdown-item > p:hover {
	color: white !important;
}

.detailImg {
	max-height: 175px !important;
}

.modal-content {
	background-color: #f7f7f7;
}

.headTopNav {
	margin-top: -2.9rem !important;
	border-bottom: 1px solid lightgray;
}

.kbbLogo {
	max-width: 4rem;
	right: 0;
	position: absolute;
}

.favicon-gif {
	margin-bottom: 35px;
}

.letter {
	font-size: 14px;
	font-family: "Roboto!important";
	color: white;
	position: absolute;
	left: 0;
	right: 0;
	margin: 0;
	top: 0;
	bottom: 0;
	text-align: center;
	line-height: 40px;
}

.reminder {
	position: absolute;
	left: 0;
	right: 0;
	margin: auto;
	top: 0;
	bottom: 0;
	line-height: 40px;
}

.profile {
	border-radius: 50%;
	width: 40px;
	position: absolute;
	top: 0;
	bottom: 0;
	margin: auto;
	right: 20px;
}

.red-close-icon {
	text-align: center;
	cursor: pointer;
	color: rgb(255, 255, 255);
	padding: 0.15rem 0.25rem;
	background: rgba(202, 6, 6, 0.6);
	border-radius: 50%;
	position: relative;
	top: 50%;
	right: 2em;
}

.red-close-icon i {
	font-size: 1.5rem;
}

.red-close-icon:hover {
	background: rgba(202, 6, 6, 0.9);
}

.text-messages-container {
	display: flex;
	flex-direction: column-reverse;
	overflow: auto;
	width: 100%;
	max-height: 30rem;
	margin: 0 auto;
	padding: 0.5rem;
}

.text-messages {
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 0.2rem;
}

#container-circles {
	position: absolute;
	left: 50%;
	bottom: 135px;
}

.camera-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 60%;
	z-index: 99999;
	padding-bottom: 1rem;
	background-color: black;
}

.camera-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100vw;
	height: 50%; /* Covering half the screen at the top */
	background: rgba(0, 0, 0, 0.7); /* semi-transparent black background */
}
.scroll-box {
	display: flex;
	justify-content: center;
	align-items: center;
}
@media screen and (max-width: 768px) {
	.scroll-box {
		justify-content: flex-start;
	}
}

.detail-header-card {
	min-width: 200px;
}

/*  action bar  */
.action-bar {
	overflow-x: auto;
	display: flex;
	position: relative;
	width: 100%;
	z-index: 100;
	min-height: 40px;
	padding-left: 15px;
	padding-right: 15px;
	align-items: center;
}

@media (min-width: 768px) {
	.action-bar {
		justify-content: center;
		margin-left: 0em;
	}
}
@media (max-width: 768px) {
	.action-bar .btn {
		padding: 0.5rem 1rem !important;
	}
}
.action-bar .btn {
	font-size: 0.8rem;
	white-space: nowrap; /* Prevent text wrapping */
	display: flex; /* Ensure content is horizontally aligned */
	align-items: center; /* Center the text vertically */
}

.no-horizontal-scrollbar,
.action-bar,
.nav-pill-bar {
	-ms-overflow-style: none;
	scrollbar-width: none;
}

.no-horizontal-scrollbar::-webkit-scrollbar,
.nav-pill-bar::-webkit-scrollbar,
.action-bar::-webkit-scrollbar {
	display: none;
}

.nav-pill-bar {
	display: flex;
	overflow-x: auto;
	gap: 10px;
	flex-wrap: nowrap;
	justify-content: flex-start;
	padding: 5px 0;
}
@media (max-width: 700px) {
	.nav-pill-bar,
	.action-bar {
		gap: 0px;
	}
}

@media (min-width: 1200px) {
	.nav-pill-bar,
	.action-bar {
		justify-content: center;
	}
}

td span div {
	text-wrap: balance;
}

/* Adding another overlay for the bottom */
.camera-overlay-bottom {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100vw;
	height: 50%; /* Covering half the screen at the bottom */
	background: rgba(0, 0, 0, 0.7);
}

.react-html5-camera-photo .video-wrapper video {
	height: auto !important;
	width: 100% !important; /* Making camera feed take full width */
	margin: 0 auto;
}

.text-messages-container::-webkit-scrollbar {
	width: 11px;
}

.text-messages-container::-webkit-scrollbar-track {
	background: rgb(231, 231, 231);
	border-radius: 25px;
}

.text-messages-container::-webkit-scrollbar-thumb {
	background: rgb(195, 195, 195);
	border-radius: 25px;
}

.text-messages-container::-webkit-scrollbar-thumb:hover {
	background: rgba(195, 195, 195, 0.8);
}

.text-messages div {
	display: flex;
	flex-direction: column;
	font-size: 0.985em;
	max-width: 15rem;
	margin-bottom: 0.3rem;
	padding: 0.4rem 0.3rem;
	line-height: 18px;
	border-radius: 17px;
}

.text-messages-time {
	font-size: 0.755em;
	margin-bottom: 0.1rem;
	padding: 0 0.2rem;
}

.text-messages-sent {
	align-self: flex-end;
	background: rgb(72, 189, 243);
	color: white;
}

.text-messages-sent .text-messages-time {
	align-self: flex-end;
	margin-left: 1rem;
}

.text-messages-received {
	align-self: flex-start;
	background: rgb(236, 236, 236);
	color: black;
}

.text-messages-sent div,
.text-messages-received div {
	white-space: pre-line;
}

.text-messages-received .text-messages-time {
	align-self: flex-start;
	margin-right: 1rem;
}

.text-messages-send-message {
	padding: 0.75rem 0.35rem 0 0.35rem;
	background: rgb(236, 236, 236);
}

.dropdown-menu {
	box-shadow: 0 0 6px rgb(179, 178, 178);
}

.ml-mobile {
	margin-left: 0.5rem;
}

@media (max-width: 768px) {
	.ml-mobile {
		margin-left: 2px;
	}
}

.close {
	position: absolute !important;
	top: 10px !important;
	right: 10px !important;
}

.text-messages-body {
	resize: none;
	padding: 0.75rem;
	border-radius: 10px;
	-ms-overflow-style: none;
	scrollbar-width: none;
	margin-top: -1rem;
}

.text-messages-body::-webkit-scrollbar {
	display: none;
}

.text-messages-preview {
	background: rgb(236, 236, 236);
}

.text-messages-preview-text {
	font-family: inherit;
	font-size: 1rem;
	padding: 0.85rem 1rem 1rem 1rem;
	white-space: pre-wrap;
}

.ReactTable .rt-th-check,
.ReactTable .rt-td-check {
	white-space: nowrap;
	text-overflow: ellipsis;
	padding: 12px 7px;
	transition: 0.3s ease;
	transition-property: width, min-width, padding, opacity;
	line-height: 2;
}
.react-select {
	width: 100px;
}
.react-select .react-select__control .react-select__indicators {
	width: 20px;
}
.forms .ReactTable .rt-tbody {
	display: revert;
}

.forms .singleCell {
	width: 100%;
	display: revert;
	text-align: left;
}

.forms .ReactTable .rt-tr {
	display: table;
}

.forms .ReactTable .rt-table .rt-td {
	text-align: revert;
	text-wrap: balance;
}

.ReactTable .rt-table {
	border: none;
}

/* Define CSS class for pink row */
.ReactTable .row-blue {
	background-color: lightblue; /* Set background color to blue */
}
.ReactTable .row-green {
	background-color: rgb(172, 241, 172); /* Set background color to green */
}
.ReactTable .row-yellow {
	background-color: lightyellow; /* Set background color to yellow */
}
.ReactTable .row-red {
	background-color: red; /* Set background color to red */
}

/* Optional: Define a hover effect */
.ReactTable .row-pink:hover {
	background-color: blue; /* Change to light coral on hover */
}

.float-end {
	float: right !important;
}

.table-caption {
	width: 100%;
	font-size: 1.57em;
	caption-side: top;
	text-align: center;
	color: black;
}

/** Twilio Blast Text Styles -- START -- **/
.blast-message-participants {
	max-height: 20rem;
	overflow-y: scroll;
	padding: 0.1rem 1rem 1rem 1rem;
}

.blast-message-participants table thead tr th {
	position: -webkit-sticky;
	position: sticky;
	top: 0;
	background-color: #ddd;
	z-index: 10;
}

.blast-message-participants table tbody tr td p {
	color: rgb(235, 14, 14);
	font-style: italic;
	font-size: 0.85em;
	padding: 0;
	margin: 0;
}
/** Twilio Blast Text Styles -- END -- **/
.checkbox-spacing {
	margin-left: 1rem;
}

form.deal-sale div,
form.deal-terms-table div {
	min-width: 50%;
}

div.deal-summary input,
.regular-payment,
.final-payment {
	background-color: transparent !important;
	box-shadow: none !important;
	border: none !important;
	font-size: 16px;
	max-width: 50%;
	min-width: 150px;
	padding: 1px;
	color: #444;
}
div.deal-summary label {
	background-color: transparent !important;
	box-shadow: none !important;
	border: none !important;
	width: -webkit-fit-content;
	width: -moz-fit-content;
	width: fit-content;
	display: inline;
	float: left;
	line-height: 125%;
	font-weight: normal;
}

.form-control {
	font-size: var(--base-font-size);
}

@media (max-width: 768px) {
	.form-control {
		font-size: 16px;
	}
}

@media (max-width: 1550px) {
	.full-width-col {
		flex: 0 0 100% !important;
		max-width: 100% !important;
	}
}

.br-6 {
	border-radius: 6px !important;
}

.maxInput {
	max-width: 600px;
}

.minInput {
	min-width: 150px;
}

@media (min-width: 768px) {
	.minInput {
		min-width: 100%;
	}
}

.regular-payment,
.deal-total input,
.amount-financed input {
	font-weight: 600 !important;
	color: #069 !important;
}

.deal-type,
.deal-type p input {
	width: 100%;
	background-color: transparent !important;
	box-shadow: none !important;
	border: none !important;
	text-align: center;
}

input[type="checkbox"] {
	height: 20px;
	width: 20px;
}

.list-group-item {
	border: none;
}

.flooring-overview {
	border: none !important;
	box-shadow: none !important;
	border: none !important;
	font-weight: 600;
	text-align: left;
	font-size: 20px;
	max-width: 50%;
	min-width: 150px;
	padding: 1px;
	color: #444;
}

.searchIcon {
	margin-right: 0.4rem;
}

#searchInput {
	width: 350px;
}
@media (max-width: 768px) {
	#searchInput {
		width: 225px !important;
	}
}

.checkbox-box {
	background-color: transparent;

	height: auto;
	max-height: 50px;
	transition: all 300ms;
	display: table;
	max-width: 100%;
	height: calc(1.5em + 0.75rem + 2px);
	padding: 0.35rem 0.1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	background-clip: padding-box;
	border: 1px solid rgba(120, 120, 120, 0.5);
	border-radius: 0.25rem;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

tr th:last-child,
tr td:last-child input,
tr td:last-child {
	text-align: right;
}

.text-right .form-control {
	text-align: right;
}

.checkbox-box .col-sm-3 {
	max-width: 100%;
	position: relative;
}

.checkbox-box .col-sm-3 input {
	position: absolute;
	width: 20px;
	height: 20px;
	bottom: 1px;
	left: 25px;
}

.bold {
	font-weight: 600;
}
.app-container {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 30px; /* Adjust the gap as needed */
	justify-content: center;
	align-items: center;
}
.checkbox-columns {
	display: flex;
	justify-content: space-between;
}

.checkbox-column {
	flex: 1 1;
}

.checkbox-item {
	display: flex;
	align-items: center;
}

.flex-space-toggle {
	margin-left: 0rem;
}
@media (min-width: 1400px) {
	.flex-space-toggle {
		justify-content: space-around;
	}
}

.rendered-card {
	min-width: 300px;
	flex: 0 0 auto;
}

@media (max-width: 600px) {
	.rendered-card {
		min-width: 93vw !important;
	}
}

@media (max-width: 1000px) {
	.rendered-card {
		min-width: 275px;
	}
}

@media (min-width: 1400px) {
	.rendered-card {
		min-width: 300px;
	}
}

@media (min-width: 1680px) {
	.rendered-card {
		min-width: 320px;
	}
}

@media (min-width: 1920px) {
	.rendered-card {
		min-width: 350px;
	}
}

@media (min-width: 2800px) {
	.rendered-card {
		min-width: 400px;
	}
}
@keyframes blink {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

.blinking-button {
	animation: blink 1s infinite;
}
.modal-minimized .modal-dialog {
	width: 300px; /* Adjust width as needed */
	margin: 0;
	position: fixed;
	bottom: 0;
	right: 0;
	left: auto;
	top: auto;
	transform: none;
}

.modal-minimized .modal-content {
	height: 60px; /* Adjust height as needed */
	overflow: hidden;
}

.modal-minimized .modal-header {
	padding: 0px; /* Adjust padding as needed */
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/custom.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;CACnC,gDAAgD;AACjD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,oBAAoB;CACpB,iBAAiB;CACjB,aAAa;AACd;AACA;CACC,iBAAiB;AAClB;AACA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;AACpB;;AAEA,oBAAoB;;AAEpB;CACC,aAAa;CACb,oBAAoB;AACrB;;AAEA;CACC,YAAY;AACb;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,aAAa;CACb,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,sBAAsB;CACtB,2BAA2B;CAC3B,4BAA4B;CAC5B;;;;EAIC;AACF;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,UAAU;CACV,eAAe;CACf,iBAAiB;CACjB,0BAA0B;AAC3B;;AAEA;;CAEC,qBAAqB;AACtB;AACA;CACC,uBAAuB;AACxB;;AAEA;CACC,eAAe;AAChB;AACA,+BAA+B;AAC/B;CACC,8BAA8B;AAC/B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA,yBAAyB;AACzB;CACC,cAAc;AACf;;AAEA;;CAEC,yBAAyB;AAC1B;AACA;CACC,kBAAkB,EAAE,uBAAuB;CAC3C,uBAAuB,EAAE,mCAAmC;AAC7D;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC;EACC,UAAU;EACV,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;CAC/B;AACD;;AAEA;CACC;EACC,8BAA8B;EAC9B,mBAAmB;CACpB;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;;CAEC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,yBAAyB;AACzB;CACC,wCAAwC;CACxC,cAAc;AACf;;AAEA;CACC,oCAAoC;CACpC,uBAAuB;AACxB;AACA,yBAAyB;AACzB;CACC,oCAAoC;CACpC,sBAAsB;AACvB;;AAEA,yBAAyB;AACzB;CACC,oCAAoC;CACpC,uBAAuB;AACxB;;AAEA,yBAAyB;AACzB;CACC,oCAAoC;AACrC;AACA,4BAA4B;;AAE5B;CACC,eAAe;AAChB;;AAEA,0BAA0B;;AAE1B;CACC,yBAAyB;CACzB,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;AACxB;;AAEA;;CAEC,UAAU;CACV,WAAW;CACX,iCAAiC;CACjC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;AAC7B;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA,kBAAkB;AAClB;CACC,cAAc;CACd,gBAAgB,EAAE,mCAAmC;CACrD,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,iBAAiB;AAClB;;AAEA,mBAAmB;AACnB;CACC,WAAW;CACX,uBAAuB;CACvB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA,0CAA0C;AAC1C;CACC,iBAAiB;AAClB;;AAEA,0DAA0D;AAC1D;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA,8DAA8D;AAC9D;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA,4DAA4D;AAC5D;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA,8DAA8D;AAC9D;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;;CAEC,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA;CACC,sCAAsC;CACtC,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;;CAEC,oBAAoB;AACrB;AACA;CACC,wBAAwB;AACzB;;AAEA;CACC,iBAAiB;AAClB;;AAEA,kBAAkB;AAClB;CACC,uBAAuB;CACvB,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,oBAAoB;AACrB;;AAEA;;CAEC,WAAW;CACX,4BAA4B;AAC7B;;AAEA;;CAEC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;;;;;;GAMG;;AAEH;CACC,gBAAgB;CAChB,gBAAgB;CAChB,WAAW;AACZ;;AAEA,qCAAqC;AACrC;CACC;;EAEC,wBAAwB;CACzB;AACD;;AAEA,qCAAqC;AACrC;CACC;;EAEC,wBAAwB;CACzB;AACD;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA,eAAe;AACf;CACC;EACC,kBAAkB;EAClB,UAAU;EACV,mBAAmB,EAAE,+BAA+B;EACpD,MAAM;CACP;CACA;EACC,yBAAyB;CAC1B;AACD;;AAEA,2BAA2B;AAC3B;CACC;mBACkB;CAClB;EACC,yBAAyB;CAC1B;;CAEA;EACC,aAAa;CACd;;CAEA;;EAEC,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;CACd;;CAEA;EACC,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,wBAAgB;EAAhB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;CACA;;EAEC,mBAAmB;EACnB,kBAAkB;CACnB;;CAEA;;;;EAIC,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,cAAc;CACf;;CAEA;EACC,uBAAuB;CACxB;;CAEA;;EAEC,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,iBAAiB;EACjB,eAAe;CAChB;CACA;EACC,cAAc;EACd,SAAO,EAAE,uCAAuC;EAChD,uBAAuB;EACvB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;CACnB;AACD;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA,4CAA4C;AAC5C;;;;;;;;;CASC,iBAAiB;AAClB;;AAEA,sBAAsB;;AAEtB;CACC,WAAW;CACX,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA,kCAAkC;AAClC;CACC,aAAa;CACb,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA,4BAA4B;AAC5B;CACC,gCAAgC;CAChC,cAAc;CACd,aAAa;CACb,uBAAoD;CAApD,oDAAoD;CACpD,mBAAmB;CACnB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;;CAEC,sBAAsB;CACtB,2CAA2C;CAC3C,uBAA2B;CAA3B,6BAA2B;CAC3B,wCAAwC;CACxC,8BAA8B;AAC/B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;;;;;CAKC;AACD;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA,0BAA0B;;AAE1B,uBAAuB;AACvB;CACC,cAAc;AACf;;AAEA,8BAA8B;AAC9B;CACC,aAAa;AACd;;AAEA,kCAAkC;AAClC;CACC;EACC,aAAa;CACd;CACA;EACC,cAAc;CACf;AACD;;AAEA;CACC,wBAAwB;CACxB,YAAY;AACb;;AAEA,qCAAqC;AACrC;CACC;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;CACX,cAAc;CACd,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA,eAAe;AACf;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC;EACC,uBAAuB;EACvB,mBAAmB;CACpB;AACD;;AAEA,yBAAyB;;AAEzB;CACC,eAAe;CACf,WAAW;CACX,cAAc;CACd,+BAA+B;CAC/B,YAAY;CACZ,eAAe;CACf,0CAA0C;CAC1C,aAAa;CACb,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,WAAW;CACX,+BAA+B;CAC/B,aAAa;CACb,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;AACA;CACC;EACC,WAAW;EACX,YAAY;CACb;AACD;;AAEA;CACC,YAAY;AACb;AACA;CACC;EACC,WAAW;CACZ;AACD;;AAEA;CACC,6BAA6B;CAC7B,QAAQ;CACR,SAAS;CACT,aAAa;AACd;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC;EACC,oBAAoB;CACrB;AACD;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC;EACC,uBAAuB;CACxB;AACD;;AAEA;CACC,aAAa;AACd;;AAEA;CACC;EACC,4BAA4B;CAC7B;AACD;;AAEA,0CAA0C;;AAE1C;CACC,8BAA8B;CAC9B,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;;CAEC,6BAA6B;CAC7B,SAAS;CACT,SAAS;CACT,8BAA8B;AAC/B;AACA;CACC,0BAA0B;AAC3B;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,oCAAoC;CACpC,sEAAsE;CACtE,wBAAwB;CACxB,yBAAyB;CACzB,iEAAiE;AAClE;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;CAC9B,kCAAkC;AACnC;;AAEA;CACC,eAAe;CACf,QAAQ;CACR,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,YAAY;CACZ,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,SAAS;CACT,MAAM;CACN,SAAS;CACT,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,YAAY;CACZ,MAAM;CACN,SAAS;CACT,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,wBAAwB;CACxB,gCAAgC;CAChC,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,cAAc;CACd,WAAW;CACX,iBAAiB;CACjB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,aAAa;AACd;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,YAAY;CACZ,WAAW;CACX,cAAc;CACd,oBAAoB;CACpB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,YAAY;CACZ,WAAW,EAAE,wCAAwC;CACrD,8BAA8B,EAAE,sCAAsC;AACvE;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC,gBAAgB;AACjB;;AAEA,iBAAiB;AACjB;CACC,gBAAgB;CAChB,aAAa;CACb,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC;EACC,uBAAuB;EACvB,gBAAgB;CACjB;AACD;AACA;CACC;EACC,+BAA+B;CAChC;AACD;AACA;CACC,iBAAiB;CACjB,mBAAmB,EAAE,0BAA0B;CAC/C,aAAa,EAAE,2CAA2C;CAC1D,mBAAmB,EAAE,+BAA+B;AACrD;;AAEA;;;CAGC,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA;;;CAGC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,SAAS;CACT,iBAAiB;CACjB,2BAA2B;CAC3B,cAAc;AACf;AACA;CACC;;EAEC,QAAQ;CACT;AACD;;AAEA;CACC;;EAEC,uBAAuB;CACxB;AACD;;AAEA;CACC,kBAAkB;AACnB;;AAEA,0CAA0C;AAC1C;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,YAAY;CACZ,WAAW,EAAE,2CAA2C;CACxD,8BAA8B;AAC/B;;AAEA;CACC,uBAAuB;CACvB,sBAAsB,EAAE,uCAAuC;CAC/D,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;CACpB,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,oBAAoB;CACpB,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,8BAA8B;CAC9B,YAAY;AACb;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;CAClC,8BAA8B;AAC/B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC,6BAA6B;CAC7B,oBAAoB;CACpB,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,mBAAmB;CACnB,wBAAwB;CACxB,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;;CAEC,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB,qBAAqB;CACrB,uDAAuD;CACvD,cAAc;AACf;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;AACZ;AACA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA,kCAAkC;AAClC;CACC,2BAA2B,EAAE,iCAAiC;AAC/D;AACA;CACC,oCAAoC,EAAE,kCAAkC;AACzE;AACA;CACC,6BAA6B,EAAE,mCAAmC;AACnE;AACA;CACC,qBAAqB,EAAE,gCAAgC;AACxD;;AAEA,oCAAoC;AACpC;CACC,sBAAsB,EAAE,mCAAmC;AAC5D;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;AACb;;AAEA,2CAA2C;AAC3C;CACC,iBAAiB;CACjB,kBAAkB;CAClB,8BAA8B;AAC/B;;AAEA;CACC,wBAAgB;CAAhB,gBAAgB;CAChB,MAAM;CACN,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;CACV,SAAS;AACV;AACA,yCAAyC;AACzC;CACC,iBAAiB;AAClB;;AAEA;;CAEC,cAAc;AACf;;AAEA;;;CAGC,wCAAwC;CACxC,2BAA2B;CAC3B,uBAAuB;CACvB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,YAAY;CACZ,WAAW;AACZ;AACA;CACC,wCAAwC;CACxC,2BAA2B;CAC3B,uBAAuB;CACvB,0BAAkB;CAAlB,uBAAkB;CAAlB,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,yBAAyB;EACzB,0BAA0B;CAC3B;AACD;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;;;CAGC,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;;CAEC,WAAW;CACX,wCAAwC;CACxC,2BAA2B;CAC3B,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,uBAAuB;CACvB,2BAA2B;CAC3B,uBAAuB;CACvB,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,YAAY;AACb;AACA;CACC;EACC,uBAAuB;CACxB;AACD;;AAEA;CACC,6BAA6B;;CAE7B,YAAY;CACZ,gBAAgB;CAChB,qBAAqB;CACrB,cAAc;CACd,eAAe;CACf,mCAAmC;CACnC,uBAAuB;CACvB,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,4BAA4B;CAC5B,0CAA0C;CAC1C,sBAAsB;CACtB,wEAAwE;AACzE;;AAEA;;;CAGC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,WAAW;CACX,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,8BAA8B;CAC9B,qBAAqB,EAAE,6BAA6B;CACpD,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,SAAO;AACR;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;AACA;CACC;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;AACD;;AAEA;CACC,4BAA4B;AAC7B;AACA;CACC,YAAY,EAAE,2BAA2B;CACzC,SAAS;CACT,eAAe;CACf,SAAS;CACT,QAAQ;CACR,UAAU;CACV,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,YAAY,EAAE,4BAA4B;CAC1C,gBAAgB;AACjB;;AAEA;CACC,YAAY,EAAE,6BAA6B;AAC5C","sourcesContent":["html * {\n\ttransition-property: all !important;\n\ttransition-duration: 0.2s ease-in-out !important;\n}\n\n.logo {\n\tmax-width: 100%;\n\tmargin-bottom: 0;\n\tpadding-right: 1.5rem;\n\tpadding-left: 1.5rem;\n\tpadding-top: 1rem;\n\tdisplay: flex;\n}\n.main-panel {\n\tmin-height: 100vh;\n}\n.miniLogo {\n\theight: 35px;\n\tdisplay: grid;\n\tmargin-bottom: 10px;\n}\n\n/* DealContent.css */\n\n.row.d-flex.align-items-stretch {\n\tdisplay: flex;\n\talign-items: stretch;\n}\n\n.card.h-100 {\n\theight: 100%;\n}\n\nhr,\n.hr {\n\tmargin: auto;\n}\n\n.cursor-pointer {\n\tcursor: pointer;\n}\n.login-form {\n\tmax-width: 350px;\n}\n\n.login-page,\nforgotten-password {\n\theight: 100vh;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-size: cover;\n\tbackground-position: center;\n\tbackground: rgb(63, 94, 251);\n\tbackground: radial-gradient(\n\t\tcircle,\n\t\trgba(63, 94, 251, 1) 0%,\n\t\trgba(0, 78, 137, 1) 100%\n\t);\n}\n\n.toggle-btn {\n\tposition: absolute;\n\tbottom: 1rem;\n\tz-index: 99;\n\tright: 3em;\n\tcursor: pointer;\n\tfont-size: 0.7rem;\n\ttext-decoration: underline;\n}\n\na:hover,\n.a:hover {\n\ttext-decoration: none;\n}\n.dropdown-menu {\n\tmin-width: 0 !important;\n}\n\n.sidebar-logo {\n\tmax-width: 100%;\n}\n/* override bs class rounding */\n.rounded {\n\tborder-radius: 12px !important;\n}\n\n.gallery-image {\n\tmax-width: 350px;\n}\n\n.inv-description {\n\tmin-height: 250px;\n\theight: \"auto\";\n\toverflow: scroll;\n}\n\n/* constrain header img */\n.headerImg {\n\tmax-width: 80%;\n}\n\n.nav-pills-primary .nav-item .nav-link,\n.nav-pills-secondary .nav-item .nav-link {\n\tcolor: #6e6e6e !important;\n}\n.larger-tabs .nav-link {\n\tfont-size: 1.25rem; /* Increase font size */\n\tpadding: 0.75rem 1.5rem; /* Adjust padding for larger tabs */\n}\n\n.bg-primary > .nav-item > .nav-link {\n\tcolor: white !important;\n}\n\n.sale-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n}\n\n.sale-item {\n\twidth: 100%;\n\tmargin-bottom: 1rem;\n}\n\n@media (min-width: 1800px) {\n\t.sale-item {\n\t\twidth: 50%;\n\t\tpadding: 0 12px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t}\n}\n\n@media (min-width: 1800px) {\n\t.sale-item .row {\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n}\n\n.sale-item .row .col-6 {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.stock-cell-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n.stock-cell-item {\n\twidth: 100%;\n\tpadding: 2px 0;\n}\n\n.singleCell .stock-cell-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.nav-pills-primary .nav-item .nav-link.active,\n.nav-pills-secondary .nav-item .nav-link.active {\n\tcolor: #fff !important;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled).active:focus {\n\tbox-shadow: none;\n}\n\n/* branded button links */\n.btn-link-danger {\n\tbackground-color: transparent !important;\n\tcolor: #c1292e;\n}\n\n.btn-link-danger:hover {\n\tbackground-color: #cc2936 !important;\n\tcolor: white !important;\n}\n/* branded button links */\n.btn-link-warning:hover {\n\tbackground-color: #fcd581 !important;\n\tcolor: #777 !important;\n}\n\n/* branded button links */\n.btn-link-success {\n\tbackground-color: #329f5b !important;\n\tcolor: white !important;\n}\n\n/* branded button links */\n.btn-link-success:hover {\n\tbackground-color: #1ada63 !important;\n}\n/* custom large top margin */\n\n.mt-10 {\n\tmargin-top: 25%;\n}\n\n/* add bg to form inputs */\n\n.input-group-prepend .input-group-text {\n\tbackground-color: #b8d5ff;\n\tpadding-right: 0.5rem !important;\n}\n\n.dropdown-item > a:hover {\n\tcolor: white !important;\n}\n\n.sidebar .logo .simple-text .logo-img img,\n.logo-img {\n\twidth: 80%;\n\theight: 80%;\n\tbackground-color: none !important;\n\tpadding: 3px;\n}\n\n.card-stats .card-body .numbers .card-category {\n\tfont-size: 14px;\n\tline-height: 1.4em;\n}\n\n.vertical-align {\n\tmargin-top: 20%;\n}\n\n.sidebar .logo a.logo-normal {\n\tpadding: 5px 0 8px;\n}\n\n.formsCard {\n\toverflow: scroll;\n}\n\n.bigText {\n\tfont-size: 1.5rem !important;\n}\n.left-align label {\n\ttext-align: left;\n}\n\n.plus-sign {\n\tline-height: 5.8em;\n}\n@media (max-width: 768px) {\n\t.plus-sign {\n\t\tline-height: 6.4em;\n\t}\n}\n\n/* Wrapper style */\n.inv-desc-box-wrapper {\n\tdisplay: block;\n\tmin-height: 20px; /* minimum height of the textarea */\n\toverflow: hidden;\n}\n\ntd > input {\n\tposition: inherit !important;\n}\n\n.card-header {\n\tpadding: 0 0.5rem;\n}\n\n/* Textarea style */\n.inv-desc-box {\n\twidth: 100%;\n\theight: 100% !important;\n\tmin-height: 100%;\n\toverflow: hidden;\n}\n\n/* Default min-height for larger screens */\n.invDescription {\n\tmin-height: 175px;\n}\n\n/* Increase min-height for large screens (1420px and up) */\n@media (min-width: 1420px) {\n\t.invDescription {\n\t\tmin-height: 250px;\n\t}\n}\n\n/* Increase min-height for medium screens (1020px to 1419px) */\n@media (min-width: 1020px) and (max-width: 1419px) {\n\t.invDescription {\n\t\tmin-height: 300px;\n\t}\n}\n\n/* Increase min-height for small screens (569px to 1019px) */\n@media (max-width: 1019px) and (min-width: 569px) {\n\t.invDescription {\n\t\tmin-height: 450px;\n\t}\n}\n\n/* Increase min-height for mobile screens (max-width: 568px) */\n@media (max-width: 568px) {\n\t.invDescription {\n\t\tmin-height: 700px;\n\t}\n}\n\n.h3,\nh3 {\n\tmargin-bottom: 0 !important;\n}\n\n.row {\n\tmargin-left: 0 !important;\n\tmargin-right: 0 !important;\n}\n\n.customNav {\n\tbox-shadow: 0 0 4px rgb(179, 178, 178);\n\tpadding-top: 0 !important;\n\tpadding-bottom: 0 !important;\n}\n\nb,\nstrong {\n\tfont-weight: lighter;\n}\n.hide {\n\tdisplay: none !important;\n}\n\n.dealImg {\n\tmax-height: 100px;\n}\n\n/* camera styles */\n.react-html5-camera-photo .video-wrapper video {\n\theight: auto !important;\n\twidth: 30% !important;\n\tmargin: 0 auto;\n}\n\n.radioFont {\n\tfont-weight: lighter;\n}\n\n.rt-td > div > img,\n.singleCell > img {\n\twidth: auto;\n\tmax-height: 6.5em !important;\n}\n\n.rt-td > div > img,\n.singleCell {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n/* @media (min-width: 1400px) {\n\t.rt-td > div > img,\n\t.singleCell > img {\n\t\twidth: auto;\n\t\tmax-height: 70px !important;\n\t}\n} */\n\n.SiriusXM {\n\tmin-width: 150px;\n\tmax-width: 250px;\n\twidth: 100%;\n}\n\n/* hide elements on smaller screens */\n@media (max-width: 1400px) {\n\t.noMobile,\n\t#noMobile {\n\t\tdisplay: none !important;\n\t}\n}\n\n/* hide elements on smaller screens */\n@media (min-width: 1400px) {\n\t.noDesktop,\n\t#noDesktop {\n\t\tdisplay: none !important;\n\t}\n}\n\n.responsive-table {\n\toverflow-x: auto;\n\twidth: 100%;\n}\n\n/* styles.css */\n@media (max-width: 768px) {\n\t.table thead th {\n\t\tposition: relative;\n\t\tz-index: 1;\n\t\tbackground: #f8f9fa; /* Adjust based on your theme */\n\t\ttop: 0;\n\t}\n\t.table-bordered thead th {\n\t\tborder: 1px solid #dee2e6;\n\t}\n}\n\n/* hide elements at 768px */\n@media (max-width: 768px) {\n\t/* .onMobileScreen,\n\t#onMobileScreen, */\n\t.ReactTable th {\n\t\tdisplay: block !important;\n\t}\n\n\t.historyButtons img {\n\t\theight: 120px;\n\t}\n\n\t.historyButtons,\n\t.modal-dialog {\n\t\twidth: 100% !important;\n\t\tmargin: 10px auto;\n\t\tpadding: 10px;\n\t}\n\n\t.partner-card {\n\t\twidth: 250px;\n\t\tcursor: pointer;\n\t}\n\n\t.sticky-header {\n\t\tposition: sticky;\n\t\ttop: 60px;\n\t\tz-index: 999999999;\n\t}\n\n\t.deal-total {\n\t\ttext-align: center;\n\t}\n\t.row .form-group,\n\t.form-group {\n\t\tpadding-right: 15px;\n\t\tpadding-left: 15px;\n\t}\n\n\t.card td,\n\t.card th,\n\t.forms-table tr,\n\t.form-group .forms-table {\n\t\tmin-width: 180px;\n\t\twidth: 100% !important;\n\t\tfloat: left;\n\t\tmargin: 0 auto;\n\t}\n\n\t.card th:first-child {\n\t\tmin-width: 0 !important;\n\t}\n\n\ttable,\n\ttbody {\n\t\toverflow: hidden;\n\t}\n\n\ttr {\n\t\tdisplay: flex;\n\t\tflex-wrap: nowrap;\n\t\tpadding: 10px 0;\n\t}\n\ttd {\n\t\tdisplay: block;\n\t\tflex: 1; /* to evenly distributs flex elements */\n\t\tborder: none !important;\n\t\tpadding: 0;\n\t\tmargin: 0px !important;\n\t\tposition: relative;\n\t}\n}\n\n.tabNav > li > a.active {\n\ttext-decoration: underline !important;\n}\n\n.tabNav:hover {\n\tcursor: pointer;\n}\n\n.tabNav {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n#actionDropdownItem:hover {\n\tbackground: none;\n}\n\n#actionDropdownItem div,\n#actionDropdownItem button {\n\twidth: 100%;\n\ttext-align: center;\n}\n\niframe[style*=\"z-index: 2147483647\"] {\n\tdisplay: none !important;\n}\n\n.pageHeader {\n\tmargin-top: 3rem;\n\tpadding-bottom: 0.5rem;\n\tmin-height: 53px;\n}\n\n@media (max-width: 768px) {\n\t.pageHeader {\n\t\tmargin-top: 0;\n\t}\n}\n\n/* line height made even for sidebar icons */\n.sidebar\n\t.sidebar-wrapper\n\t> .nav\n\t[data-toggle=\"collapse\"]\n\t~ div\n\t> ul\n\t> li\n\t> a\n\ti {\n\tline-height: 30px;\n}\n\n/* move to sass file */\n\n.btn.btn-link-black {\n\tcolor: #000;\n\tbackground-color: transparent;\n}\n\n.rt-resizable-header-content {\n\ttext-align: center;\n}\n\n.sidebar[data-color=\"sidebar\"] .nav li a {\n\tcolor: #f7f7f7;\n}\n\n/* add red asterix to req fields */\n.required:after {\n\tcontent: \" *\";\n\tcolor: red;\n}\n\n.font-xs {\n\tfont-size: 0.8em;\n}\n\n/* Styling for table cells */\n.singleCell {\n\tfont-size: var(--base-font-size);\n\tpadding: 0 3px;\n\tdisplay: flex;\n\tjustify-content: var(--cell-justify-content, center);\n\talign-items: center;\n\tflex-direction: row;\n\toverflow: hidden;\n}\n\n.table-auto-width tr > td:first-child,\n.table-auto-width tr > th:first-child {\n\twidth: auto !important;\n\t/* Override min-width for the first child */\n\tmin-width: unset !important;\n\t/* If flex is causing issues, reset it */\n\tdisplay: table-cell !important;\n}\n\n.status {\n\tfont-size: 14px;\n\tfont-weight: 400;\n}\n/*\n.sidebar-mini .sidebar {\n\tdisplay: block;\n\tz-index: 999999;\n}\n*/\n.mt-half {\n\tmargin-top: 0.8rem;\n}\n\n.lg-p {\n\tfont-size: 1rem;\n}\n\n.pt-3-half {\n\tpadding-top: 1.3rem !important;\n}\n\n.selector {\n\tmin-width: 200px;\n}\n\n.main-panel .content {\n\tpadding-left: 0;\n\tpadding-right: 0;\n}\n\ntable tbody tr td input {\n\tbackground-color: inherit;\n}\n\n.lenderImg {\n\theight: 80px !important;\n\tmargin-bottom: 12px;\n}\n\n.bodyHeight {\n\tmin-height: 110vh !important;\n}\n\n.adImage {\n\tmax-height: 45px !important;\n\tmargin-bottom: 10px;\n}\n\n.modal-xl {\n\tmax-width: 94% !important;\n}\n\n.btn i,\n.navbar .navbar-nav > a.btn i {\n\tmargin-right: 0 !important;\n}\n\n/* InventoryListData.css */\n\n/* Default table view */\n.inventory-table {\n\tdisplay: block;\n}\n\n/* Hide card view by default */\n.inventory-card-list {\n\tdisplay: none;\n}\n\n/* Switch to card view at 1400px */\n@media (max-width: 1400px) {\n\t.inventory-table {\n\t\tdisplay: none;\n\t}\n\t.inventory-card-list {\n\t\tdisplay: block;\n\t}\n}\n\n.btn {\n\toutline: none !important;\n\tborder: none;\n}\n\n/* hide elements on smaller screens */\n@media (max-width: 1920px) {\n\t.sidebarText {\n\t\tdisplay: none !important;\n\t}\n}\n\n.old-row {\n\tmargin: 0 -15px !important;\n}\n\n.customer-profile {\n\tmax-height: 128px;\n\tmargin-bottom: 0.3rem;\n\tbox-shadow: 0 0 2px darkgrey;\n}\n\n.hide {\n\tdisplay: none;\n}\n\n.bottom-nav a {\n\tfloat: left;\n\tdisplay: block;\n\tcolor: #f2f2f2;\n\ttext-align: center;\n\tpadding: 14px 16px;\n\ttext-decoration: none;\n\tfont-size: 17px;\n}\n\n.bottom-nav a:hover {\n\tbackground: #f1f1f1;\n\tcolor: black;\n}\n\n.bottom-nav a.active {\n\tbackground-color: #04aa6d;\n\tcolor: white;\n}\n\n.btn-active {\n\tbackground-color: #04aa6d;\n\tcolor: #5a5a5a;\n}\n\n/* styles.css */\n.toggle-button {\n\tbackground-color: inherit;\n}\n\n.toggleContainer {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin: 0.5rem 0;\n}\n\n@media (max-width: 768px) {\n\t.toggleContainer {\n\t\tjustify-content: center;\n\t\tmargin-bottom: 20px;\n\t}\n}\n\n/* floating save button */\n\n.float-button {\n\tposition: fixed;\n\tright: 20px;\n\tbottom: -115px;\n\ttransition: all 0.2s ease-in 0s;\n\tz-index: 999;\n\tcursor: pointer;\n\tbox-shadow: 0 0 2px 0px rgb(179, 178, 178);\n\theight: 150px;\n\tfont-size: 16px;\n\tfont-weight: 600;\n}\n\n.hi-z-index {\n\tz-index: 9999;\n}\n\n.float-button:hover {\n\tbottom: -110px;\n\tfont-size: 18px;\n}\n\n.float-button-modal {\n\tposition: fixed;\n\tright: 135px;\n\tbottom: 30px;\n\tleft: 170px;\n\ttransition: all 0.2s ease-in 0s;\n\tz-index: 9999;\n\tcursor: pointer;\n\ttext-align: right;\n}\n\n.welcomeImage {\n\twidth: 500px;\n\theight: 300px;\n}\n@media screen and (max-width: 768px) {\n\t.welcomeImage {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n}\n\n.article-card {\n\twidth: 18rem;\n}\n@media screen and (max-width: 768px) {\n\t.article-card {\n\t\twidth: 100%;\n\t}\n}\n\n.headerToggle {\n\tposition: absolute !important;\n\ttop: 4px;\n\tleft: 49%;\n\tz-index: 9999;\n}\n.pt-6 {\n\tpadding-top: 3.5rem;\n}\n\n.col-xl-6 {\n\tflex: 0 0 49%;\n}\n\n.collapse-button {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.collapse-content.collapsed {\n\tdisplay: none;\n}\n\n.collapsed-content.expanded {\n\tdisplay: block;\n}\n\n@media (max-width: 768px) {\n\t.mobile-pb-1 {\n\t\tpadding-bottom: 1rem;\n\t}\n}\n\n.btn-block + .btn-block {\n\tmargin-top: 0 !important;\n}\n\n.attachmentBtnCol {\n\tjustify-content: flex-start;\n}\n\n@media (max-width: 768px) {\n\t.attachmentBtnCol {\n\t\tjustify-content: center;\n\t}\n}\n\n.modal-body {\n\tpadding: 15px;\n}\n\n@media (max-width: 1300px) {\n\t.mobileHeading {\n\t\tpadding-top: 5rem !important;\n\t}\n}\n\n/* lazy but i cant find in sass files... */\n\n.vehicle-photo img {\n\tborder-radius: 10px !important;\n\toverflow: hidden !important;\n\tmargin-top: 10px;\n}\n\n.nav-pills-primary .nav-item .nav-link,\n.nav-pills-secondary .nav-item .nav-link {\n\tbox-shadow: 0 0 2px #00000042;\n\tborder: 0;\n\tmargin: 0;\n\tborder-radius: 30px !important;\n}\n.css-12jo7m5 {\n\tfont-size: 18px !important;\n}\n\n.nav-search,\n.search {\n\tdisplay: none;\n}\n\n.avatar {\n\tmax-width: 30px;\n\tpadding-top: 0.4rem;\n}\n\n.content {\n\tmargin-top: 60px !important;\n}\n\n.main-panel {\n\tbackground-color: #f7f7f7 !important;\n\ttransition: all 0rgb (173, 173, 173) c-bezier(0.685, 0.0473, 0.346, 1);\n\ttransition-property: all;\n\ttransition-duration: 0.5s;\n\ttransition-timing-function: cubic-bezier(0.685, 0.0473, 0.346, 1);\n}\n\n.main-panel > .content {\n\tpadding: 0;\n}\n\n.dropdown-item > p:hover {\n\tcolor: white !important;\n}\n\n.detailImg {\n\tmax-height: 175px !important;\n}\n\n.modal-content {\n\tbackground-color: #f7f7f7;\n}\n\n.headTopNav {\n\tmargin-top: -2.9rem !important;\n\tborder-bottom: 1px solid lightgray;\n}\n\n.kbbLogo {\n\tmax-width: 4rem;\n\tright: 0;\n\tposition: absolute;\n}\n\n.favicon-gif {\n\tmargin-bottom: 35px;\n}\n\n.letter {\n\tfont-size: 14px;\n\tfont-family: \"Roboto!important\";\n\tcolor: white;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0;\n\ttop: 0;\n\tbottom: 0;\n\ttext-align: center;\n\tline-height: 40px;\n}\n\n.reminder {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\tmargin: auto;\n\ttop: 0;\n\tbottom: 0;\n\tline-height: 40px;\n}\n\n.profile {\n\tborder-radius: 50%;\n\twidth: 40px;\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tmargin: auto;\n\tright: 20px;\n}\n\n.red-close-icon {\n\ttext-align: center;\n\tcursor: pointer;\n\tcolor: rgb(255, 255, 255);\n\tpadding: 0.15rem 0.25rem;\n\tbackground: rgba(202, 6, 6, 0.6);\n\tborder-radius: 50%;\n\tposition: relative;\n\ttop: 50%;\n\tright: 2em;\n}\n\n.red-close-icon i {\n\tfont-size: 1.5rem;\n}\n\n.red-close-icon:hover {\n\tbackground: rgba(202, 6, 6, 0.9);\n}\n\n.text-messages-container {\n\tdisplay: flex;\n\tflex-direction: column-reverse;\n\toverflow: auto;\n\twidth: 100%;\n\tmax-height: 30rem;\n\tmargin: 0 auto;\n\tpadding: 0.5rem;\n}\n\n.text-messages {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tpadding: 0.2rem;\n}\n\n#container-circles {\n\tposition: absolute;\n\tleft: 50%;\n\tbottom: 135px;\n}\n\n.camera-container {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100vw;\n\theight: 60%;\n\tz-index: 99999;\n\tpadding-bottom: 1rem;\n\tbackground-color: black;\n}\n\n.camera-overlay {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100vw;\n\theight: 50%; /* Covering half the screen at the top */\n\tbackground: rgba(0, 0, 0, 0.7); /* semi-transparent black background */\n}\n.scroll-box {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n@media screen and (max-width: 768px) {\n\t.scroll-box {\n\t\tjustify-content: flex-start;\n\t}\n}\n\n.detail-header-card {\n\tmin-width: 200px;\n}\n\n/*  action bar  */\n.action-bar {\n\toverflow-x: auto;\n\tdisplay: flex;\n\tposition: relative;\n\twidth: 100%;\n\tz-index: 100;\n\tmin-height: 40px;\n\tpadding-left: 15px;\n\tpadding-right: 15px;\n\talign-items: center;\n}\n\n@media (min-width: 768px) {\n\t.action-bar {\n\t\tjustify-content: center;\n\t\tmargin-left: 0em;\n\t}\n}\n@media (max-width: 768px) {\n\t.action-bar .btn {\n\t\tpadding: 0.5rem 1rem !important;\n\t}\n}\n.action-bar .btn {\n\tfont-size: 0.8rem;\n\twhite-space: nowrap; /* Prevent text wrapping */\n\tdisplay: flex; /* Ensure content is horizontally aligned */\n\talign-items: center; /* Center the text vertically */\n}\n\n.no-horizontal-scrollbar,\n.action-bar,\n.nav-pill-bar {\n\t-ms-overflow-style: none;\n\tscrollbar-width: none;\n}\n\n.no-horizontal-scrollbar::-webkit-scrollbar,\n.nav-pill-bar::-webkit-scrollbar,\n.action-bar::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.nav-pill-bar {\n\tdisplay: flex;\n\toverflow-x: auto;\n\tgap: 10px;\n\tflex-wrap: nowrap;\n\tjustify-content: flex-start;\n\tpadding: 5px 0;\n}\n@media (max-width: 700px) {\n\t.nav-pill-bar,\n\t.action-bar {\n\t\tgap: 0px;\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.nav-pill-bar,\n\t.action-bar {\n\t\tjustify-content: center;\n\t}\n}\n\ntd span div {\n\ttext-wrap: balance;\n}\n\n/* Adding another overlay for the bottom */\n.camera-overlay-bottom {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\twidth: 100vw;\n\theight: 50%; /* Covering half the screen at the bottom */\n\tbackground: rgba(0, 0, 0, 0.7);\n}\n\n.react-html5-camera-photo .video-wrapper video {\n\theight: auto !important;\n\twidth: 100% !important; /* Making camera feed take full width */\n\tmargin: 0 auto;\n}\n\n.text-messages-container::-webkit-scrollbar {\n\twidth: 11px;\n}\n\n.text-messages-container::-webkit-scrollbar-track {\n\tbackground: rgb(231, 231, 231);\n\tborder-radius: 25px;\n}\n\n.text-messages-container::-webkit-scrollbar-thumb {\n\tbackground: rgb(195, 195, 195);\n\tborder-radius: 25px;\n}\n\n.text-messages-container::-webkit-scrollbar-thumb:hover {\n\tbackground: rgba(195, 195, 195, 0.8);\n}\n\n.text-messages div {\n\tdisplay: flex;\n\tflex-direction: column;\n\tfont-size: 0.985em;\n\tmax-width: 15rem;\n\tmargin-bottom: 0.3rem;\n\tpadding: 0.4rem 0.3rem;\n\tline-height: 18px;\n\tborder-radius: 17px;\n}\n\n.text-messages-time {\n\tfont-size: 0.755em;\n\tmargin-bottom: 0.1rem;\n\tpadding: 0 0.2rem;\n}\n\n.text-messages-sent {\n\talign-self: flex-end;\n\tbackground: rgb(72, 189, 243);\n\tcolor: white;\n}\n\n.text-messages-sent .text-messages-time {\n\talign-self: flex-end;\n\tmargin-left: 1rem;\n}\n\n.text-messages-received {\n\talign-self: flex-start;\n\tbackground: rgb(236, 236, 236);\n\tcolor: black;\n}\n\n.text-messages-sent div,\n.text-messages-received div {\n\twhite-space: pre-line;\n}\n\n.text-messages-received .text-messages-time {\n\talign-self: flex-start;\n\tmargin-right: 1rem;\n}\n\n.text-messages-send-message {\n\tpadding: 0.75rem 0.35rem 0 0.35rem;\n\tbackground: rgb(236, 236, 236);\n}\n\n.dropdown-menu {\n\tbox-shadow: 0 0 6px rgb(179, 178, 178);\n}\n\n.ml-mobile {\n\tmargin-left: 0.5rem;\n}\n\n@media (max-width: 768px) {\n\t.ml-mobile {\n\t\tmargin-left: 2px;\n\t}\n}\n\n.close {\n\tposition: absolute !important;\n\ttop: 10px !important;\n\tright: 10px !important;\n}\n\n.text-messages-body {\n\tresize: none;\n\tpadding: 0.75rem;\n\tborder-radius: 10px;\n\t-ms-overflow-style: none;\n\tscrollbar-width: none;\n\tmargin-top: -1rem;\n}\n\n.text-messages-body::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.text-messages-preview {\n\tbackground: rgb(236, 236, 236);\n}\n\n.text-messages-preview-text {\n\tfont-family: inherit;\n\tfont-size: 1rem;\n\tpadding: 0.85rem 1rem 1rem 1rem;\n\twhite-space: pre-wrap;\n}\n\n.ReactTable .rt-th-check,\n.ReactTable .rt-td-check {\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tpadding: 12px 7px;\n\ttransition: 0.3s ease;\n\ttransition-property: width, min-width, padding, opacity;\n\tline-height: 2;\n}\n.react-select {\n\twidth: 100px;\n}\n.react-select .react-select__control .react-select__indicators {\n\twidth: 20px;\n}\n.forms .ReactTable .rt-tbody {\n\tdisplay: revert;\n}\n\n.forms .singleCell {\n\twidth: 100%;\n\tdisplay: revert;\n\ttext-align: left;\n}\n\n.forms .ReactTable .rt-tr {\n\tdisplay: table;\n}\n\n.forms .ReactTable .rt-table .rt-td {\n\ttext-align: revert;\n\ttext-wrap: balance;\n}\n\n.ReactTable .rt-table {\n\tborder: none;\n}\n\n/* Define CSS class for pink row */\n.ReactTable .row-blue {\n\tbackground-color: lightblue; /* Set background color to blue */\n}\n.ReactTable .row-green {\n\tbackground-color: rgb(172, 241, 172); /* Set background color to green */\n}\n.ReactTable .row-yellow {\n\tbackground-color: lightyellow; /* Set background color to yellow */\n}\n.ReactTable .row-red {\n\tbackground-color: red; /* Set background color to red */\n}\n\n/* Optional: Define a hover effect */\n.ReactTable .row-pink:hover {\n\tbackground-color: blue; /* Change to light coral on hover */\n}\n\n.float-end {\n\tfloat: right !important;\n}\n\n.table-caption {\n\twidth: 100%;\n\tfont-size: 1.57em;\n\tcaption-side: top;\n\ttext-align: center;\n\tcolor: black;\n}\n\n/** Twilio Blast Text Styles -- START -- **/\n.blast-message-participants {\n\tmax-height: 20rem;\n\toverflow-y: scroll;\n\tpadding: 0.1rem 1rem 1rem 1rem;\n}\n\n.blast-message-participants table thead tr th {\n\tposition: sticky;\n\ttop: 0;\n\tbackground-color: #ddd;\n\tz-index: 10;\n}\n\n.blast-message-participants table tbody tr td p {\n\tcolor: rgb(235, 14, 14);\n\tfont-style: italic;\n\tfont-size: 0.85em;\n\tpadding: 0;\n\tmargin: 0;\n}\n/** Twilio Blast Text Styles -- END -- **/\n.checkbox-spacing {\n\tmargin-left: 1rem;\n}\n\nform.deal-sale div,\nform.deal-terms-table div {\n\tmin-width: 50%;\n}\n\ndiv.deal-summary input,\n.regular-payment,\n.final-payment {\n\tbackground-color: transparent !important;\n\tbox-shadow: none !important;\n\tborder: none !important;\n\tfont-size: 16px;\n\tmax-width: 50%;\n\tmin-width: 150px;\n\tpadding: 1px;\n\tcolor: #444;\n}\ndiv.deal-summary label {\n\tbackground-color: transparent !important;\n\tbox-shadow: none !important;\n\tborder: none !important;\n\twidth: fit-content;\n\tdisplay: inline;\n\tfloat: left;\n\tline-height: 125%;\n\tfont-weight: normal;\n}\n\n.form-control {\n\tfont-size: var(--base-font-size);\n}\n\n@media (max-width: 768px) {\n\t.form-control {\n\t\tfont-size: 16px;\n\t}\n}\n\n@media (max-width: 1550px) {\n\t.full-width-col {\n\t\tflex: 0 0 100% !important;\n\t\tmax-width: 100% !important;\n\t}\n}\n\n.br-6 {\n\tborder-radius: 6px !important;\n}\n\n.maxInput {\n\tmax-width: 600px;\n}\n\n.minInput {\n\tmin-width: 150px;\n}\n\n@media (min-width: 768px) {\n\t.minInput {\n\t\tmin-width: 100%;\n\t}\n}\n\n.regular-payment,\n.deal-total input,\n.amount-financed input {\n\tfont-weight: 600 !important;\n\tcolor: #069 !important;\n}\n\n.deal-type,\n.deal-type p input {\n\twidth: 100%;\n\tbackground-color: transparent !important;\n\tbox-shadow: none !important;\n\tborder: none !important;\n\ttext-align: center;\n}\n\ninput[type=\"checkbox\"] {\n\theight: 20px;\n\twidth: 20px;\n}\n\n.list-group-item {\n\tborder: none;\n}\n\n.flooring-overview {\n\tborder: none !important;\n\tbox-shadow: none !important;\n\tborder: none !important;\n\tfont-weight: 600;\n\ttext-align: left;\n\tfont-size: 20px;\n\tmax-width: 50%;\n\tmin-width: 150px;\n\tpadding: 1px;\n\tcolor: #444;\n}\n\n.searchIcon {\n\tmargin-right: 0.4rem;\n}\n\n#searchInput {\n\twidth: 350px;\n}\n@media (max-width: 768px) {\n\t#searchInput {\n\t\twidth: 225px !important;\n\t}\n}\n\n.checkbox-box {\n\tbackground-color: transparent;\n\n\theight: auto;\n\tmax-height: 50px;\n\ttransition: all 300ms;\n\tdisplay: table;\n\tmax-width: 100%;\n\theight: calc(1.5em + 0.75rem + 2px);\n\tpadding: 0.35rem 0.1rem;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\tcolor: #495057;\n\tbackground-clip: padding-box;\n\tborder: 1px solid rgba(120, 120, 120, 0.5);\n\tborder-radius: 0.25rem;\n\ttransition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\ntr th:last-child,\ntr td:last-child input,\ntr td:last-child {\n\ttext-align: right;\n}\n\n.text-right .form-control {\n\ttext-align: right;\n}\n\n.checkbox-box .col-sm-3 {\n\tmax-width: 100%;\n\tposition: relative;\n}\n\n.checkbox-box .col-sm-3 input {\n\tposition: absolute;\n\twidth: 20px;\n\theight: 20px;\n\tbottom: 1px;\n\tleft: 25px;\n}\n\n.bold {\n\tfont-weight: 600;\n}\n.app-container {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgrid-column-gap: 30px; /* Adjust the gap as needed */\n\tjustify-content: center;\n\talign-items: center;\n}\n.checkbox-columns {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.checkbox-column {\n\tflex: 1;\n}\n\n.checkbox-item {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.flex-space-toggle {\n\tmargin-left: 0rem;\n}\n@media (min-width: 1400px) {\n\t.flex-space-toggle {\n\t\tjustify-content: space-around;\n\t}\n}\n\n.rendered-card {\n\tmin-width: 300px;\n\tflex: 0 0 auto;\n}\n\n@media (max-width: 600px) {\n\t.rendered-card {\n\t\tmin-width: 93vw !important;\n\t}\n}\n\n@media (max-width: 1000px) {\n\t.rendered-card {\n\t\tmin-width: 275px;\n\t}\n}\n\n@media (min-width: 1400px) {\n\t.rendered-card {\n\t\tmin-width: 300px;\n\t}\n}\n\n@media (min-width: 1680px) {\n\t.rendered-card {\n\t\tmin-width: 320px;\n\t}\n}\n\n@media (min-width: 1920px) {\n\t.rendered-card {\n\t\tmin-width: 350px;\n\t}\n}\n\n@media (min-width: 2800px) {\n\t.rendered-card {\n\t\tmin-width: 400px;\n\t}\n}\n@keyframes blink {\n\t0% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n\n.blinking-button {\n\tanimation: blink 1s infinite;\n}\n.modal-minimized .modal-dialog {\n\twidth: 300px; /* Adjust width as needed */\n\tmargin: 0;\n\tposition: fixed;\n\tbottom: 0;\n\tright: 0;\n\tleft: auto;\n\ttop: auto;\n\ttransform: none;\n}\n\n.modal-minimized .modal-content {\n\theight: 60px; /* Adjust height as needed */\n\toverflow: hidden;\n}\n\n.modal-minimized .modal-header {\n\tpadding: 0px; /* Adjust padding as needed */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
